// Footer menu media query boundaries
export const menuContainerQueryMinWidth = '900px'
export const menuContainerQueryMaxWidth = '899px'
export const menuContainerLinkQueryMaxWidth = '899px';

// Naviation menu media query boundaries
export const navMenuLinkQueryMinWidth = '900px'
export const navMenuLinkQueryMaxWidth = '899px'
export const navmenuNameLinkQueryMaxWidth = '899px';
export const navmenuItemLinkQueryMaxWidth = '899px';